import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import LoadingSpinner from './LoadingSpinner'

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, role, loading } = useAuth()
  const location = useLocation()

  if (loading) return <LoadingSpinner fullScreen />

  if (!user) {
    // Redirect to correct login based on which route they tried to access
    if (location.pathname.startsWith('/superadmin')) {
      return <Navigate to="/platform/login" replace />
    }
    if (
      location.pathname.startsWith('/admin') ||
      location.pathname.startsWith('/coordinator')
    ) {
      return <Navigate to="/staff/login" replace />
    }
    return <Navigate to="/login" replace />
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    // Redirect to correct dashboard based on their actual role
    if (role === 'super_admin') return <Navigate to="/superadmin" replace />
    if (role === 'club_admin') return <Navigate to="/admin" replace />
    if (role === 'chapter_coordinator') return <Navigate to="/coordinator" replace />
    return <Navigate to="/dashboard" replace />
  }

  return children
}